import getCookie from './readCookie';

export default function getCSRFToken() {
  return decodeURIComponent(getCookie('csrfToken'));
}
